/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JwTokenModel } from '../../models/jw-token-model';

export interface RegisterTwoFactor$Params {
      body?: {
'sharedKey'?: string;
'oneTimePassword'?: string;
'webAuthnKey'?: string;
}
}

export function RegisterTwoFactor(http: HttpClient, rootUrl: string, params?: RegisterTwoFactor$Params, context?: HttpContext): Observable<StrictHttpResponse<JwTokenModel>> {
  const rb = new RequestBuilder(rootUrl, RegisterTwoFactor.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JwTokenModel>;
    })
  );
}

RegisterTwoFactor.PATH = '/api/Account/RegisterTwoFactor';
